/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import cx from 'classnames';

export default function LoadingBar({
  isVisible,
}: {
  isVisible: boolean,
}): Element<string> {
  return (
    <div
      className={cx({ 'is-visible': isVisible })}
      css={css(`
          animation: loader-progress 1000ms linear 1;
          opacity: 0;
          transition: opacity 1000ms;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: #1181fb;
          z-index: 2;

        &.is-visible {
          animation: loader-progress 2000ms linear infinite;
          opacity: 1;
        }

        @keyframes loader-progress {
          0% {
            width: 0;
          }
          100% {
            width: 100%;
          }
        }

      `)}
    />
  );
}
